export default "__VITE_ASSET__bItF81pQ__"